import {Injectable} from '@angular/core';
import {HttpClient} from "@angular/common/http";
import {MinizaemApiClientService} from "../../core/services/minizaem-api-client.service";
import {Observable} from "rxjs";

@Injectable({
  providedIn: 'root'
})
export class ContactService extends MinizaemApiClientService {

  sendEmail(name: string, email: string, phone: string, text: string, recaptchaResponseToken: string): Observable<any> {
    const formData = new FormData();
    formData.append('email', email);
    formData.append('name', name);
    formData.append('phone', phone);
    formData.append('text', text);
    formData.append('recaptchaResponseToken', recaptchaResponseToken);

    return this.http.post(this.buildURI("api/send-email")
      , formData
    );
  }
}
